import Vue from 'vue'
import './styles/new/_handle.scss'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import preview from '@/components/ImagePreview'
import browser from '@/utils/browser'
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole)
Vue.use(VueCookies)
// 引入样式: 忽略主题的判断，加载蓝主题定义为客户主题色
require('@/styles/reset.scss')
require('@/styles/base.scss')

Vue.config.$axios = axios

Vue.config.productionTip = false
// 或者使用 CDN 引入后
const versions = browser.versions()
console.log('==================*******=================')
console.log('window.PLATFORM=====:', window.PLATFORM)
console.log('versions.mobile=====:', versions.mobile)
console.log('Vue.prototype.env=====:', Vue.prototype.env)
console.log('==================*******=================')
Vue.prototype.env = window.PLATFORM = versions.mobile ? versions.weiXin ? 'weChat' : 'h5' : 'pc'
// 先注册platform信息再初始化 vue app
import('./store')
  .then(({ default: store }) => {
    return new Promise((resolve) => {
      const compLoader = store.state.appConfig.isMaintaining
        ? import('./Maintain.vue')
        : import('./App.vue')
      compLoader.then(
        ({ default: app }) => {
          return resolve({
            store,
            app
          })
        },
        (err) => {
          console.log(err)
        }
      )
    })
  })
  .then(({ store, app }) => {
    new Vue({
      store,
      render: (h) => h(app),
      created () {
        store.dispatch('getRobotConfig')
      },
      mounted () {
        // 为所有的图片绑定处理时间
        document.body.addEventListener(
          'click',
          function (e) {
            /**
             * 为对话框中的 img 委托事件查看大图
             */
            function isImgInPop (target) {
              if (target.tagName !== 'IMG') {
                return false
              }
              let isWrapperInPop = false
              let parent = target.parentNode
              while (target.parentNode) {
                parent = parent.parentNode
                if (parent.className.indexOf('text-message__txt') >= 0) {
                  isWrapperInPop = true
                  break
                }
              }
              return isWrapperInPop
            }
            const target = e.target
            if (isImgInPop(target)) {
              preview(target.getAttribute('src'))
            }
          },
          false
        ) // 事件捕获模型绑定事件
      }
    }).$mount('#app')
  })
